import { useState } from "react";
import { useSearchParams, Link, useNavigate } from "react-router-dom";
import api, { formatApiError } from "../lib/api";
import SEO from "../components/SEO";
import { Input } from "../components/ui/input";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) return toast.error("Passwords do not match");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: password });
      toast.success("Password updated — please log in with your new password");
      navigate("/login");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-20" data-testid="reset-password-page">
      <SEO title="Reset Password" description="Set a new Humaira Crafts account password" />
      <h1 className="text-4xl tracking-tighter font-semibold text-center mb-10">Set a New Password</h1>
      {!token ? (
        <div className="text-center">
          <p className="text-sm text-muted-foreground">This reset link is invalid. Please request a new one.</p>
          <Link to="/login" className="inline-block mt-6 small-caps text-gold border-b border-gold" data-testid="reset-back-login">Back to Login</Link>
        </div>
      ) : (
        <form onSubmit={submit} className="flex flex-col gap-4">
          <Input required type="password" placeholder="New password (min 6 characters)" value={password} onChange={(e) => setPassword(e.target.value)} className="bg-white" data-testid="reset-password" />
          <Input required type="password" placeholder="Confirm new password" value={confirm} onChange={(e) => setConfirm(e.target.value)} className="bg-white" data-testid="reset-password-confirm" />
          <button type="submit" disabled={loading} className="bg-[#111] text-[#FAF9F6] py-4 small-caps hover:bg-gold hover:text-[#111] transition-colors duration-300 disabled:opacity-50" data-testid="reset-submit">
            {loading ? "Updating..." : "Update Password"}
          </button>
        </form>
      )}
    </div>
  );
}
